/**
 * ONEFOLD same-page section links.
 *
 * Menu links such as "/#how-it-works" or "/#faq" point at homepage sections. When the page the
 * visitor is on has a section with that same id (e.g. the product page's own "How it works"),
 * scroll to it instead of navigating to the homepage. Otherwise the link behaves normally.
 * If the link is inside the menu drawer, the drawer is closed first so scrolling isn't locked.
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target instanceof Element ? event.target.closest('a[href*="#"]') : null;
    if (!link || link.target === '_blank') return;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.hash.length < 2) return;
    if (url.pathname === window.location.pathname) return; // same page: the browser handles it

    const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return; // section not on this page: go to the linked page as usual

    event.preventDefault();

    const drawer = link.closest('header-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();

    // Give the drawer time to close and release its scroll lock before scrolling.
    window.setTimeout(
      () => {
        target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        history.pushState(null, '', url.hash);
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      },
      drawer ? 350 : 0
    );
  });
})();
